import firebase from '@firebase/app';
import axios from 'axios';

export const sendNotificationFirebase = async () => {

  let notification = {
    "notification": {
      "title": "New name",
      "text": `Iago is awesome`,
      "sound": "default"
    },
    "data": {
      "volume": "3.21.15",
      "contents": "http://www.news-magazine.com/world-week/21659772"
    },
    "to": "c1A7CpDewo0:APA91bEoOK7YgLKzic8hnQzvtV1cunL2Y3zdg65Qs4DrCST0L0CktnkK1525fE4Xf0jtXWKEOEe-TasHdIDPP1eHCeLRRDw-JQefSh-V9jbTrLRTBODv8h45xSmahnqnCl2ggoPmmME5",
    "priority": "high"
  }

  let request = {
    url: "https://fcm.googleapis.com/fcm/send",
    method: 'post',
    headers: {
      "Content-Type": "application/json",
      "Authorization": "key=AAAA4MJhiVo:APA91bFQJpbej6Z-sDCXBPFs_D4ehdIsHJOnHtglm_Fqa7tRmD6iUcWqkXvXHPexuhhxCIToJaQ5M2vBSa7u3-b1ZAJ2nu3MtrfaLMwNtcR6H3sfpiUPSsx8B48q3UllcoN_s_0Ffa8i"
    },
    data: notification
  }

  console.log("Tentando enviar mensagem");
  try {


    let response = await axios(request);

    console.log("RESPOSTA OK: ", response)
    return response;

  } catch (error) {

    console.log("RESPOSTA ERRO: ", error)
    return error;

  }




}


// WEBPACK FOOTER //
// src/dao-firebase/notification-firebase.js